export default __webpack_public_path__ + "static/van_suv-b89beda965369cddf4062205c00f79d2.svg";